// extracted by mini-css-extract-plugin
export default {"closeButton":"zoom_closeButton__cIPlJ"};